import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  AppBar,
  Toolbar,
  IconButton,
  Stack,
  Chip,
  List,
  Button,
  Divider,
  Dialog,
  DialogContent,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { parseISO, format } from "date-fns";
import { AuthContext } from "../context/AuthContext";
import { CITIES } from "../data/CITIES";
import getCoupons from "../api/coupon/getCoupons";
import getRewardCards from "../api/rewardcard/getRewardCards";
import zhTW from "date-fns/locale/zh-TW";
import buyCoupon from "../api/user/buyCoupon";
import ConfirmDialog from "../component/ConfirmDialog";
import { id } from "date-fns/locale";
const RewardCardPage = () => {
  const [rewardCards, setRewardCards] = useState([]);
  const [cities, setCities] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [showPoints, setShowPoints] = useState(0);
  const [cardCount, setCardCount] = useState(0);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [selectedButton, setSelectedButton] = useState(null);
  const [msgDialogOpen, setMsgDialogOpen] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const userContext = useContext(AuthContext);
  const maxAvatars = 10; // Max avatars to display

  useEffect(() => {
    async function fetchRewardCards() {
      try {
        const response = await getRewardCards();

        if (response.RewardCards !== null && response.Code === "000") {
          setRewardCards(response.RewardCards);
        }
      } catch (error) {
        console.error("Failed to fetch coupons", error);
      }
    }

    const fetchCoupons = async () => {
      try {
        const response = await getCoupons();
        let coupons = [];

        if (response.Coupons)
          coupons = response.Coupons.filter(
            (coupon) =>
              coupon.IsValid &&
              coupon.CanBeSold &&
              new Date() < new Date(coupon.EndDate)
          );
        setCoupons(coupons);

      } catch (err) {
        console.error(err.message);
      }
    };

    if (coupons) {
      fetchCoupons();

    }

    if (userContext.user !== null) fetchRewardCards();
  }, []);

  useEffect(() => {
    let tmpCity = {};
    let cityArray = [];

    for (var key in rewardCards) {
      tmpCity[rewardCards[key].City] = 1;
    }
    for (key in tmpCity) {
      cityArray.push(key);
    }

    cityArray.sort((a, b) => {
      return CITIES.indexOf(a) - CITIES.indexOf(b);
    });
    let rewardCardIndex=rewardCards.findIndex(card=>card.City===selectedButton)
    if (!isNaN(Math.floor(rewardCards[rewardCardIndex]?.Points / maxAvatars))) {
      setCardCount(Math.floor(rewardCards[rewardCardIndex]?.Points / maxAvatars));
    }

    if (!isNaN(rewardCards[rewardCardIndex]?.Points % maxAvatars)) {
      setShowPoints(rewardCards[rewardCardIndex]?.Points % maxAvatars);
    }
    setCities(cityArray);

    if(!selectedButton)setSelectedButton(cityArray[0]);
  }, [rewardCards]);
  useEffect(()=>{
    let rewardCardIndex=rewardCards.findIndex(card=>card.City===selectedButton)
    if (!isNaN(Math.floor(rewardCards[rewardCardIndex]?.Points / maxAvatars))) {
      setCardCount(Math.floor(rewardCards[rewardCardIndex]?.Points / maxAvatars));
    }

    if (!isNaN(rewardCards[rewardCardIndex]?.Points % maxAvatars)) {
      setShowPoints(rewardCards[rewardCardIndex]?.Points % maxAvatars);
    }
  },[selectedButton])

  const buyCoupounClick = (coupon) => {
    const cityIndex = rewardCards.findIndex(card=>card.City===selectedButton);
    
    const callBuyCoupons = async () => {
      try {

        const response = await buyCoupon(coupon.Id, selectedButton);
        fetchRewardCards()
      } catch (err) {
        console.error(err.message);
      }
    };
    async function fetchRewardCards() {
      try {
        const response = await getRewardCards();

        if (response.RewardCards !== null && response.Code === "000") {

          setRewardCards(response.RewardCards);
        }
      } catch (error) {
        console.error("Failed to rewardCard", error);
      }
    }
    if (rewardCards[cityIndex]?.Points >= coupon.Points){ 
      callBuyCoupons();

    }
  };

  const parsedDate = (inputDateString) => {
    const date = parseISO(inputDateString, "dd-MM-yyyy HH:mm", new Date());
    const formattedDate = format(date, "yyyy/MM/dd HH:mm");

    return formattedDate;
  };

  const RewardCard = () => {
    let rewardCardIndex=rewardCards.findIndex(card=>card.City===selectedButton)

    return (
      <Card sx={{ bgcolor: "gray", maxWidth: "370px" }}>
        <CardContent>
          <Typography
            align="center"
            variant="h5"
            fontWeight={"bold"}
            color={"#fffabf"}
            component="div"
          >
            集點卡
          </Typography>
          <Grid
            container
            spacing={2}
            marginTop={1}
            alignItems="center"
            justifyContent="center"
          >

            {Array.from({ length: maxAvatars }).map((_, index) => (
              <Grid key={index} style={{ width: "20%" }}>
                <Avatar
                  src={
                    isNaN(
                      rewardCards[rewardCardIndex]?.Points
                    ) ||
                    rewardCards[rewardCardIndex]?.Points === 0
                      ? null
                      : showPoints === 0
                      ? "/logo192.png"
                      : index < showPoints
                      ? "/logo192.png"
                      : null
                  }
                  sx={{
                    width: 56,
                    height: 56,
                  }}
                >
                  {""}
                </Avatar>
              </Grid>
            ))}
          </Grid>
        </CardContent>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          color={theme.palette.text.selected}
          marginX={1}
        >

          <Typography color={"#fffabf"}>{`限${
            rewardCards[rewardCardIndex]?.City || ""
          }`}</Typography>
          <Typography color={"#fffabf"}>
            {cardCount === 0 ? `第1張` : `第${cardCount}張`}
          </Typography>

          <Typography color={"#fffabf"}>{`共${
            rewardCards[rewardCardIndex]?.Points || 0
          }點`}</Typography>
        </Stack>
      </Card>
    );
  };

  const handleBackButtonClick = () => {
    navigate(-1);
  };
  return (
    <Box
      width="100%"
      height="100vh"
      sx={{ backgroundColor: theme.palette.background.default }}
    >
      <AppBar position="static" color="primary" sx={{ marginBottom: 1 }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="back"
            onClick={handleBackButtonClick}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            alignSelf="center"
            fontSize={"h6.fontSize"}
            fontWeight={"bold"}
          >
            優惠券
          </Typography>
        </Toolbar>
      </AppBar>
      {userContext.user === null ? (
        <Typography
          marginTop={20}
          fontSize={"h5.fontSize"}
          fontWeight={"bold"}
          align="center"
        >
          尚未登入
        </Typography>
      ) : (
        <Box>
          {cities.map((label, index) => (
            <Chip
              key={index}
              label={label}
              // Set the variant based on the selected state
              variant={selectedButton === label ? "contained" : "outlined"}
              // Set the click handler to update the selected button
              onClick={() => setSelectedButton(label)}
              style={{ margin: "3px" }} // Add some margin between buttons
              sx={{
                fontSize: "12pt",
                backgroundColor:
                  selectedButton === label ? theme.palette.selected : "default",
                color:
                  selectedButton === label
                    ? theme.palette.text.selected
                    : "default",
                "&:focus": {
                  backgroundColor: theme.palette.selected,
                  color: theme.palette.text.selected,
                },
              }}
            ></Chip>
          ))}
          <Box
            marginTop={1}
            marginBottom={2}
            justifyContent={"center"}
            display={"flex"}
          >
            <RewardCard />
          </Box>

          {coupons.map((coupon, index) => (
            <React.Fragment key={index}>
              <Card sx={{ marginX: 1 }}>
                <CardContent>
                  <Stack
                    direction={"row"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                  >
                    <Box>
                      <Stack direction={"row"} alignItems={"center"}>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          fontSize={22}
                          fontWeight={"bold"}
                        >
                          {coupon.Name}
                        </Typography>
                      </Stack>
                      <Stack>
                        <Typography color={theme.palette.text.secondary}>
                          {coupon.Description}
                        </Typography>
                        <Typography
                          color={theme.palette.text.secondary}
                          marginTop={1}
                        >
                          {coupon.ValidDays > 0
                            ? `兌換後可用${coupon.ValidDays}天`
                            : `使用期限:${format(
                                new Date(coupon.StartDate),
                                "yyyy/MM/dd",
                                { locale: zhTW }
                              )}~${format(
                                new Date(coupon.EndDate),
                                "yyyy/MM/dd",
                                {
                                  locale: zhTW,
                                }
                              )}`}
                        </Typography>
                      </Stack>
                    </Box>

                    <Button
                      disabled={
                        rewardCards[rewardCards.findIndex(card=>card.City===selectedButton)]?.Points <
                        coupon.Points
                      }
                      sx={{
                        bgcolor: theme.palette.primary.main,
                        boxShadow: 1,
                        borderRadius: 1,
                        width: "30%",

                        fontWeight: "bold",
                        alignItems: "center", // Vertically centers the text
                        justifyContent: "center", // Horizontally centers the text
                        "&:focus": {
                          bgcolor: "gray",
                        },
                      }}
                      variant="outlined"
                      color="info"
                      onClick={() => {
                        setSelectedCoupon(coupon);
                        setMsgDialogOpen(true);
                      }}
                    >
                      {rewardCards[rewardCards.findIndex(card=>card.City===selectedButton)]?.Points >=
                      coupon.Points
                        ? `${coupon.Points}點兌換`
                        : "點數不足"}
                    </Button>
                  </Stack>
                </CardContent>
              </Card>

              <Divider variant="inset" />
            </React.Fragment>
          ))}
        </Box>
      )}
      <ConfirmDialog
        open={msgDialogOpen}
        onConfirm={() => {
          buyCoupounClick(selectedCoupon);
        }}
        title={"兌換優惠券"}
        content={"是否兌換優惠券"}
        onClose={() => {
          setMsgDialogOpen(false);
        }}
      ></ConfirmDialog>
    </Box>
  );
};

export default RewardCardPage;
